import {
    BsHouse,
    BsShopWindow
} from "react-icons/bs";
import {
    PiBed
} from "react-icons/pi";

export const enquiryOptions = (t, jacuzzi = false) => ({
    "Studio": {
        value: "Studio",
        label: jacuzzi ? t("studio-jacuzzi") : t("studio"),
        icon: <BsHouse size={18} />,
    },
    "1 Bedroom": {
        value: "1 Bedroom",
        label: jacuzzi ? t("1bhk-jacuzzi") : t("1bhk"),
        icon: <PiBed size={18} />,
    },
    "2 Bedrooms": {
        value: "2 Bedrooms",
        label: jacuzzi ? t("2bhk-jacuzzi") : t("2bhk"),
        icon: <PiBed size={18} />,
    },
    "3 Bedrooms": {
        value: "3 Bedrooms",
        label: jacuzzi ? t("3bhk-jacuzzi") : t("3bhk"),
        icon: <PiBed size={18} />,
    },
    "4 Bedrooms": {
        value: "4 Bedrooms",
        label: jacuzzi ? t("4bhk-jacuzzi") : t("4bhk"),
        icon: <PiBed size={18} />,
    },
    "5 Bedrooms": {
        value: "5 Bedrooms",
        label: jacuzzi ? t("5bhk-jacuzzi") : t("5bhk"),
        icon: <PiBed size={18} />,
    },
    "6 Bedrooms": {
        value: "6 Bedrooms",
        label: jacuzzi ? t("6bhk-jacuzzi") : t("6bhk"),
        icon: <PiBed size={18} />,
    },
    "7 Bedrooms": {
        value: "7 Bedrooms",
        label: jacuzzi ? t("7bhk-jacuzzi") : t("7bhk"),
        icon: <PiBed size={18} />,
    },
    "Retail": {
        value: "Retail",
        label: t("retail"),
        icon: <BsShopWindow size={18} />,
    },
    "Offices": {
        value: "Offices",
        label: t("offices"),
        icon: <BsShopWindow size={18} />,
    },
});
